export default "__VITE_ASSET__BiBbFKYo__"